import { render, staticRenderFns } from "./StandardDeck.vue?vue&type=template&id=73abb08e&scoped=true&"
import script from "./StandardDeck.vue?vue&type=script&lang=js&"
export * from "./StandardDeck.vue?vue&type=script&lang=js&"
import style0 from "./StandardDeck.vue?vue&type=style&index=0&id=73abb08e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73abb08e",
  null
  
)

export default component.exports